import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { BUILD_PATH } from "../constants/app.constants";
import { Layout } from "./layout";
import Overview from "../modules/overview";
import Login from "../modules/login";
import ResetPassword from "../modules/login/resetPassword";
import Invoicing from "../modules/invoicing";
import ClientConnection from "../modules/clientconnection";
import Quotes from "../modules/quotes";
import Scheduling from "../modules/scheduling";
import Pages from "../pages";

const Routing = () => {
  const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
      const userId = window.localStorage.getItem("ID");
      const expiryStr = window.localStorage.getItem("session_expiry");
      const expiry = expiryStr ? Number(expiryStr) : 0;

      const isExpired = !expiry || Number.isNaN(expiry) || (Date.now() > expiry);

      // If no user or session expired → logout user
      if (!userId || isExpired) {
        window.localStorage.clear();
        navigate(`/${BUILD_PATH}login`, { replace: true });
      }
    }, [navigate]);

    // Render guard: do not show children until session is validated
    const userId = window.localStorage.getItem("ID");
    const expiryStr = window.localStorage.getItem("session_expiry");
    const expiry = expiryStr ? Number(expiryStr) : 0;
    const isExpired = !expiry || Number.isNaN(expiry) || Date.now() > expiry;

    if (!userId || isExpired) {
      return null; // Could also return a loader if needed
    }

    return <>{children}</>;
  };

  return (
    <Routes>
      <Route path={`/${BUILD_PATH}`} element={<Login />} />
      <Route path={`/${BUILD_PATH}login`} element={<Login />} />
      <Route path={`/${BUILD_PATH}reset`} element={<ResetPassword />} />
      <Route path="pages" element={<Pages />} />

      <Route
        path={`/${BUILD_PATH}overview`}
        element={
          <RequireAuth>
            <Layout>
              <Overview />
            </Layout>
          </RequireAuth>
        }
      />

      <Route
        path={`/${BUILD_PATH}invoicing`}
        element={
          <RequireAuth>
            <Layout>
              <Invoicing />
            </Layout>
          </RequireAuth>
        }
      />

      <Route
        path={`/${BUILD_PATH}clientconnection`}
        element={
          <RequireAuth>
            <Layout>
              <ClientConnection />
            </Layout>
          </RequireAuth>
        }
      />

      <Route
        path={`/${BUILD_PATH}quotes`}
        element={
          <Layout>
            <Quotes />
          </Layout>
        }
      />

      <Route
        path={`/${BUILD_PATH}scheduling`}
        element={
          <RequireAuth>
            <Layout>
              <Scheduling />
            </Layout>
          </RequireAuth>
        }
      />

      <Route path={`/${BUILD_PATH}forgotpassword`} element={<Login />} />
    </Routes>
  );
};

export default Routing;
